import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';

import './App.css';
import store, { persistor } from './store';
import Layout from './components/Layouts/Layout';
import { ThemeProvider } from './context/ThemeContext';
import { AdminProvider } from './context/AdminContext';
import { BrandingProvider } from './context/BrandingContext';
import ErrorBoundary from './components/Utility/ErrorBoundary';
import ChatDock from './components/agent/ChatDock';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <ErrorBoundary>
            <ThemeProvider>
              <BrandingProvider>
                <AdminProvider>
                  <Layout />
                  <ChatDock />
                </AdminProvider>
                <ToastContainer />
              </BrandingProvider>
            </ThemeProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
